/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 13:38:34
 * @LastEditors: jing
 * @LastEditTime: 2021-04-08 14:45:45
 * @Description: file content
 */
import Vue from 'vue/dist/vue.js'
import modalDrawForm from "./components/modal-draw-form";
import modalGuide from "./components/modal-guide";
import modalPoster from "./components/modal-poster";
import modalShare from "./components/modal-share";
import modalBirdForm from "./components/modal-bird-form";
import modalBirdContinue from "./components/modal-bird-continue";
import modalBirdFail from "./components/modal-bird-fail";
import modalBirdThank from "./components/modal-bird-thank";
import modalBirdSuccess from "./components/modal-bird-success";
import moderRemind from "./components/moder-remind";
import moderLottery from "./components/model-kaijiang";
// import modalRrp from "./components/modal-rrp";
let myPlugin = {
  options: null,
};
myPlugin.install = function (Vue) {
  Vue.prototype.$modal = {
    guide: modalGuide,
    poster: modalPoster,
    share: modalShare,
    birdForm: modalBirdForm,
    birdContinue: modalBirdContinue,
    birdFail: modalBirdFail,
    birdThank: modalBirdThank,
    birdSuccess: modalBirdSuccess,
    drawForm: modalDrawForm,
    RemindForm:moderRemind,
    drawSuccess: moderLottery,
  };
};
Vue.use(myPlugin);